import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import './Print.css';
import PdfStore from '../../stores/PdfStore'
import Moment from 'moment';
import * as Convert from './ConvertNumberToText.js'
import FontAwsome from 'react-fontawesome'
import {Button} from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
var NotificationSystem = require('react-notification-system');
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543)
var cssPagedMedia = (function() {
  var style = document.createElement('style');
  document.head.appendChild(style);
  return function (rule) {
    style.innerHTML = rule;
  };
}());
cssPagedMedia.size = function(size) {
  cssPagedMedia('@page {size: ' + size + '}');
};
class PrintVoucherDoc extends Component {

  constructor(props){
    super(props)
    this.DEFAULT_ROW = (this.props.docName==='receiptvoucher_doc'?15:20)
    this.state = {
      data:{itemlist:[],amount:0,withholdamount:0,witholdpercentage:0,condition_amount:0,fee_amount:0},
      dataList:[],
      options:[
        // {name: "show_remark", title: "แสดงหมายเหตุ", value: false},
        // {name: "show_car", title: "แสดงรายละเอียดรถ", value: false},
        // {name: "show_tel", title: "แสดงเบอร์โทรศัพท์", value: false},
        // {name: "hide_issue_date", title: "ไม่แสดงวันที่เอกสาร", value: false},
        // {name: "hide_logo", title: "ไม่แสดงโลโก้", value: false},
        // {name: "hide_header", title: "ไม่แสดงหัวเอกสาร", value: false}
      ],
      report_title:'กำลังดึงข้อมูล..',
      defaultTypePrint:'3',
      itemPerPage:this.DEFAULT_ROW,
      title:this.props.title,
      sizePage:{page:'a4-onlineview'},
      pay_type:null
    }
    cssPagedMedia.size('portrait');
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {added_by:'',added_date:'',bf_work_damage_id:'',cost_per_unit:'',detail:'',discount_amount:'',discount_percent:'',export_stock_flag:'',fix_flag:'',itemnum:'',paint_flag:'',part_cost:'',part_flag:'',part_from:'',price_on_shop:'',price_per_unit:'',productcode:'',quantity:'',row_style:'',seq:'',stock_flag:'',wage_cost:'',wage_itemnum:'',wait_insurer_flag:'',work_no:''}
    })
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
    this.loadPrintConfigOptions()
  }

  loadPrintConfigOptions() {
    let {options} = this.state
    PdfStore.loadPrintConfigOptions(this.props.docName,(result) => {
        options = Object.assign(result.data, options)
        this.setState({options:options})
    },()=>{
      
    })
  }

  loadData(itemPerPage) {
    let {options,data} = this.state
    PdfStore.loadGeneralSlipDoc(this.props.docNo,this.props.docName,(result) => {
      options = Object.assign(result.options, options)
      data = Object.assign(data,result.data)
      this.setState({title:result.data.doc_title,report_title:'ไม่พบข้อมูล',data:data,dataList:this.getPagination(result.data.itemlist,itemPerPage),options:options})
    },()=>{
      this.setState({report_title:'เกิดข้อผิดพลาด'})
    })
  }

  getValid(value) {
		value = (value===''?0:value===null?0:value===undefined?0:isNaN(value)?0:value*1)
		return value
	}

  getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getBalance(amount,deposit_amount) {
    let sum = 0
    if (amount===''||amount===null||amount===undefined||isNaN(amount))
      amount = 0

    if (deposit_amount===''||deposit_amount===null||deposit_amount===undefined||isNaN(deposit_amount))
      deposit_amount = 0

    sum = amount - deposit_amount
    return sum
  }

  getAmountPerRow(index) {
    let {data} = this.state
    let {docName} = this.props
		let amount = 0
		if (docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc') {
      amount = this.getValid(data.itemlist[index].total)

      // amount = this.getValid(data.itemlist[index].amount)

			// if (data.itemlist[index].has_vat)
			// 	amount = this.getValid(data.itemlist[index].amount)
			// else
			// 	amount = this.getValid(data.itemlist[index].total)
		} else {
			let quantity = this.getValid(data.itemlist[index].quantity)
			let price_per_unit = this.getValid(data.itemlist[index].price_per_unit)
			let discount_amount = this.getValid(data.itemlist[index].discount_amount)
			amount += (quantity*price_per_unit)-discount_amount
		}	
		return amount
	}

  getTotalBeforeVat() {
    let {data} = this.state
    let {docName} = this.props
    let sum = 0
    if (docName==='receiptvoucher_doc') {
      data.itemlist.forEach((item,index)=>{
				sum += parseFloat(this.getAmountPerRow(index))
			})
    } else {
      data.itemlist.forEach((item,index)=>{
        sum += parseFloat(this.getAmountPerRow(index))
      })
      if (data.vat_type==='VAT_INCLUDE') {
        sum = sum/1.07
      }
    }  
  	return sum
  }

  getVat() {
    let {data} = this.state
    let {docName} = this.props
    let sum = 0
    if (docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc') {
      let sum_vat = 0
      data.itemlist.forEach((item,index)=>{
        if (item.vat>0) { 
          sum_vat += (this.getValid(item.amount)*1)
        }
      })
      if (data.vat_type==='VAT_INCLUDE'||typeof data.vat_type==='undefined'){
        sum_vat = sum_vat/1.07
      }
      sum = (sum_vat * 0.07)  
      return sum
    } else {
      if (data.vat_type==='VAT_EXCLUDE') {
        sum = (this.getTotalBeforeVat()*7)/100
        return sum
      } else if (data.vat_type==='VAT_INCLUDE') {
        sum = (this.getTotalBeforeVat() * 0.07) 
        return sum
      } else {
        return sum
      }
    }  
  }

  getNetTotal() {
    let sum = 0
    sum = (this.getTotalBeforeVat()*1) + (this.getVat()*1)
    return sum
  }

  getThaiFormat() { 
    let amount = Math.ceil(this.getNetTotal()*1)
    return amount > 0 ? Convert.ArabicNumberToText(amount) : 'ศูนย์บาทถ้วน'
  }

  getAmountBeforeVatPerRow(item) {
    return item.total-item.vat
  }

  onTypePrintChange(e) {
    this.setState({defaultTypePrint:e})
  }

  onOptionSetingChange(items) {
    this.setState({options:items})
  }

  onOptionSizeChange(size) {
    let {sizePage} = this.state
    sizePage.page = (size.value==='A5'?'a5-onlineview':'a4-onlineview')

    this.setState({sizePage:sizePage})
    this.loadData(this.state.itemPerPage)
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  onSavePrintConfigOptions() {
    let {options} = this.state
    let postData = {data:options}
    PdfStore.savePrintConfigOptions(this.props.docName,postData,(result)=>{
      if (result.status==='OK') {
        this.refs.notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ทำการบันทึกตั้งค่าการพิมพ์เรียบร้อย',
          level: 'info',
          position: 'tc',   
        })
      }
    })
  }

  onResetPrintConfigOptions() {
    PdfStore.resetPrintConfigOptions(this.props.docName,(result)=>{
      if (result.status==='OK') {
        this.refs.notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ทำการรีเซ็ตตั้งค่าการพิมพ์เรียบร้อย',
          level: 'info',
          position: 'tc',   
        })
        this.setState({options:result.data})
      }
    })
  }

  renderLogoUrl(logoUrl){
    let {sizePage} = this.state
    let imgUrl = ''
    if (process.env.NODE_ENV === "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/img/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img alt='' src={imgUrl} style={{border:'none',width:(sizePage.page==='a5-onlineview'?'120px':'')}} />)
  }
  
  renderHeader(item,index) {
    let {data,defaultTypePrint,options,sizePage} = this.state
    let hideLogo = options.find((item,index)=>{
      return item.name==='hide_logo'&&item.value
    })
    let hideHeader = options.find((item,index)=>{
      return item.name==='hide_header'&&item.value
    })
    return([
              <header className='title-header' key={'_H'}>
                <h2 className='font-print-40'>{this.state.title}</h2>
              </header>,  
              <article className={"article-company "+data.logo_class} key={'_A'}>
                <div style={{textAlign:'center',lineHeight:'70px',visibility:(hideHeader?'hidden':'')}}> {/* width:(sizePage.page==='a5-onlineview'?'120px':data.logo_width+'px'),minWidth:(sizePage.page==='a5-onlineview'?'120px':data.logo_width+'px'), */}
                  {hideLogo?<br/>:this.renderLogoUrl(data.logo_url)}
                </div>
                <section style={{width:'85%',paddingTop:(data.logo_class==='bg-logo-absolute'?'0':'15px'),visibility:(hideHeader?'hidden':'')}}>
                  <strong>
                    <p className="font-header" style={{lineHeight:'0.7'}}>{(data.company_name!==undefined?data.company_name:'')}</p>
                    <p className="font-header" style={{lineHeight:'0.7'}}>{data.company_addr!==undefined?data.company_addr:''}</p>
                    <p className="font-header" style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษี {(data.company_tax!==undefined?data.company_tax:'')}</p>
                    <p className="font-header" style={{lineHeight:'0.7'}}>โทร {(data.company_tel!==undefined?data.company_tel:'')}</p>              
                  </strong>
                </section>
                <section className='text-right sec-copy-doc'>
                  <span id='sec-copy-doc' style={{display:defaultTypePrint==='0'?'none':''}}>{item.type==='ori'?'ต้นฉบับ':item.type==='copy'?'สำเนา':''}</span>
                </section>
              </article>
    ])
  }

  renderCarDetail() {
    let {data,options} = this.state
    let hideCar = options.find((item,index)=>{
      return item.name==='show_car'&&item.value
    })
    return(
      <div style={{marginBottom:'10px',display:(hideCar?'':'none')}}>
        <table className='table table-print-payment-note-doc'>
          <tbody>
            <tr>
              <td className='text-center font-print-24' style={{width:'25%'}}>ทะเบียน</td>
              <td className='text-center font-print-24' style={{width:'25%'}}>เลขตัวถัง</td>
              <td className='text-center font-print-24' style={{width:'25%'}}>รุ่น</td>
              <td className='text-center font-print-24' style={{width:'25%'}}>เลขกิโลเมตร/ไมล์</td>
            </tr>
            <tr>
              <td className='text-center font-print-24'>{data.car_registration_no!==undefined?data.car_registration_no:<br/>}</td>
              <td className='text-center font-print-24'>{data.chassis_no!==undefined?data.chassis_no:<br/>}</td>
              <td className='text-center font-print-24'>{data.model!==undefined?data.model:<br/>}</td>
              <td className='text-center font-print-24'>{data.mileage!==undefined?data.mileage:<br/>}</td>
            </tr>
          </tbody>
        </table>
      </div>  
    )
  }

  renderBody() {
    let {data,options} = this.state
    let hideDate = options.find((item,index)=>{
      return item.name==='hide_issue_date'&&item.value
    })
    let hideTel = options.find((item,index)=>{
      return item.name==='show_tel'&&item.value
    })
    let hideCustomer = options.find((item,index)=>{
      return item.name==='hide_customer'&&item.value
    })
    let hideCar = options.find((item,index)=>{
      return item.name==='show_car'&&item.value
    })
    return(
        <div style={{width:'100%'}}>
      		<div className='customer-detail' style={{display:'inline-block',width:'69.5%',border:'1px solid',marginBottom:'5px',marginRight:'0.5%',height:'110px'}}>
	          <table className='x-table table-header-print-payment-note-doc' style={{marginBottom:'0',visibility:(hideCustomer?'hidden':'')}}>
	            <tbody>
	              <tr>
	                <td className='font-print-24'>{this.props.docName==='paymentvoucher_doc'?'จ่ายให้':'ชื่อลูกค้า'} {data.customer_name}</td>
	              </tr>
                <tr>
	                <td className='font-print-24'>ที่อยู่ {data.customer_address}</td>
	              </tr>
                <tr style={{display:(hideTel?'':'none')}}>
	                <td className='font-print-24'>โทร. {data.customer_tel}</td>
	              </tr>
                <tr>
	                <td className='font-print-24'>เลขประจำตัวผู้เสียภาษี {data.customer_tax}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>
	        <div className='customer-detail' style={{display:'inline-block',width:'29.5%',border:'1px solid',marginBottom:'5px',marginLeft:'0.5%',height:'110px'}}>
	          <table className='x-table table-header-print-payment-note-doc' style={{marginBottom:'0'}}>
	            <tbody>
	              <tr>
	                <td className='font-print-24' style={{width:'100px'}}>เลขที่</td>
	                <td className='font-print-24'>{this.props.docNo}</td>
	              </tr>
	              <tr style={{display:(hideDate?'none':'')}}>
	                <td className='font-print-24' style={{width:'100px'}}>วัน/เดือน/ปี</td>
	                <td className='font-print-24'>{data.added_date!==undefined?data.added_date:TODAY}</td>
	              </tr>
                <tr>
	                <td className='font-print-24' style={{width:'100px'}}>เลขอ้างอิง</td>
	                <td className='font-print-24'>{data.ref_no}</td>
	              </tr>
                <tr style={{display:(hideCar?'':'none')}}>
	                <td className='font-print-24' style={{width:'100px'}}>ยี่ห้อ</td>
                  <td className='font-print-24'>{data.brand!==undefined?data.brand:<br/>}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>  
      	</div>
    )
  }

  renderTable(dataItem,dataIndex,length,number) {
    let {data,options,pay_type} = this.state
    let {docName,showTaxInvoiceRefItem} = this.props
    let wh = data.withholdpercentage
    let hideName = options.find((item,index)=>{
      return item.name==='hide_receiving_by'&&item.value
    })
    let hideName1 = options.find((item,index)=>{
      return item.name==='hide_signed_by'&&item.value
    })
    let text = options.find((item,index)=>{
      return item.name==='receiving_by_title'
    })
    let text1 = options.find((item,index)=>{
      return item.name==='signed_by_title'
    })
    
    return(
          <div>
            <table className='table table-print-payment-note-doc'>
              <tbody>
                <tr>
                  <td rowSpan={showTaxInvoiceRefItem==='true'?2:1} className='text-center font-print-24' style={{width:'50px'}}>ลำดับ</td>
                  {showTaxInvoiceRefItem==='true'?
                  <td className='text-center font-print-24' colSpan={2}>ใบกำกับภาษี</td>
                  :''}
                  <td rowSpan={showTaxInvoiceRefItem==='true'?2:1} className='text-center font-print-24' style={{width:'400px'}}>รายการ</td>
                  <td rowSpan={showTaxInvoiceRefItem==='true'?2:1} className='text-center font-print-24' style={{width:docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'75px':'70px'}}>
                    {docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'มูลค่าสินค้า':'จำนวน'}
                  </td>
                  <td rowSpan={showTaxInvoiceRefItem==='true'?2:1} className='text-center font-print-24' style={{width:docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'60px':'90px'}}>
                    {docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'Vat 7%':'ราคา/หน่วย'}
                  </td>
                  <td rowSpan={showTaxInvoiceRefItem==='true'?2:1} className='text-center font-print-24' style={{width:'75px'}}>
                    {docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'จำนวนเงินรวม':'มูลค่าก่อนภาษี'}
                  </td>
                </tr>
                {showTaxInvoiceRefItem==='true'?
                <tr>
                  <td style={{width:'140px'}} className='text-center font-print-24'>หมายเลข</td>
                  <td style={{width:'90px'}} className='text-center font-print-24'>วัน/เดือน/ปี</td>
                </tr>
                :''}
                {this.renderRowData(dataItem,dataIndex,length,number)}
                {/* <tr style={{display:(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':'')}}>            
                  <td rowSpan={((data.vat_type==='NON_VAT'||data.vat_type===undefined)&&(wh==='0'||wh===undefined))?1:((data.vat_type==='NON_VAT'||data.vat_type===undefined)&&(wh!=='0'||wh!==undefined))?6:((data.vat_type!=='NON_VAT'||data.vat_type!==undefined)&&(wh==='0'||wh===undefined))?6:8} colSpan={showTaxInvoiceRefItem==='true'?4:2} className='text-center font-print-24' style={{verticalAlign:'middle'}}>{this.getThaiFormat()}</td>
                  <td colSpan={2} className='text-center font-print-24'>มูลค่าตามเอกสารเดิม</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(data.taxinvoice_amount)}</td>
                </tr>
                <tr style={{display:(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':'')}}>
                  <td colSpan={2} className='text-center font-print-24'>มูลค่าที่ถูกต้อง</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat((data.taxinvoice_amount*1)+(this.getTotalBeforeVat()*1))}</td>
                </tr>
                <tr style={{display:(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':'')}}>
                  <td colSpan={2} className='text-center font-print-24'>ผลต่าง</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(this.getTotalBeforeVat())}</td>
                </tr> */}
                <tr style={{display:(docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'':(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':''))}}>
                  <td 
                    className='text-center font-print-24'
                    style={{verticalAlign:'middle',display:(docName==='receiptvoucher_doc'?'':'none')}}
                    rowSpan={docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?(wh==='0'||wh===undefined||!dataItem.footer?3:5):1}
                    colSpan={showTaxInvoiceRefItem==='true'?4:2}
                  >  
                  </td>
                  <td 
                    className='text-center font-print-24'
                    style={{verticalAlign:'middle',display:(docName==='paymentvoucher_doc'?'':'none')}}
                    rowSpan={((data.vat_type==='NON_VAT'||data.vat_type===undefined)&&(wh==='0'||wh===undefined))?1:((data.vat_type==='NON_VAT'||data.vat_type===undefined)&&(wh!=='0'||wh!==undefined))?3:((data.vat_type!=='NON_VAT'||data.vat_type!==undefined)&&(wh==='0'||wh===undefined))?3:5} 
                    colSpan={showTaxInvoiceRefItem==='true'?4:2} className='text-center font-print-24'
                  >  
                  </td>
                  <td colSpan={2} className='text-center font-print-24'>{docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'ยอดรวมก่อนภาษี	':(data.vat_type==='NON_VAT'?'ราคารวม':'Total Price/ราคารวม')}</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(this.getTotalBeforeVat())}</td>
                </tr>
                <tr style={{display:(docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'':(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':''))}}>
                  <td colSpan={2} className='text-center font-print-24'>{docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'ภาษีมูลค่าเพิ่ม 7%':'Vat/ภาษีมูลค่าเพิ่ม 7%'}</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(this.getVat())}</td>
                </tr>
                <tr style={{display:(docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'':(data.vat_type==='NON_VAT'||data.vat_type===undefined||!dataItem.footer?'none':''))}}>
                  <td colSpan={2} className='text-center font-print-24'>{docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'ยอดรวมสุทธิ':'Net Price/ราคาสุทธิ'}</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(this.getNetTotal())}</td>
                </tr>
                <tr style={{display:(wh==='0'||wh===undefined||!dataItem.footer?'none':'')}}>
                  <td colSpan={2} className='text-center font-print-24'>หักภาษี ณ ที่จ่าย {wh}%</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(data.withholdamount)}</td>
                </tr>
                <tr style={{display:(wh==='0'||wh===undefined||!dataItem.footer?'none':'')}}>
                  <td colSpan={2} className='text-center font-print-24'>ยอดชำระ</td>
                  <td className='text-right font-print-24'>{this.getNumberFormat(this.getNetTotal()-data.withholdamount)}</td>
                </tr>
                <tr style={{display:(dataItem.footer&&docName==='receiptvoucher_doc'?'':'none')}}>
                  <td colSpan={showTaxInvoiceRefItem==='true'?4:2} className='text-center font-print-24'>
                    {this.renderPayType()}
                  </td>
                  <td style={{verticalAlign:'bottom'}} colSpan={3} className='text-center font-print-24'>
                    <div>ผู้มีอำนาจ/อนุมัติ................................</div>
                    <div>วันที่ ....../....../......</div>
                  </td>
                </tr>
                {docName!=='receiptvoucher_doc'
                ?
                <tr style={{display:(dataItem.footer?'':'none')}}>
                  <td colSpan={showTaxInvoiceRefItem==='true'?4:2} className='text-center font-print-24'>
                    <br/>
                    <div style={{visibility:(hideName?'hidden':'')}}>...........................................&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;...........................................</div>
                    <div style={{visibility:(hideName?'hidden':'')}}>{docName==='paymentvoucher_doc'||docName==='receiptvoucher_doc'?'ผู้จัดทำ':'ผู้รับของ'} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {docName==='paymentvoucher_doc'||docName==='receiptvoucher_doc'?'ผู้รับเงิน':'ผู้ส่งของ'}</div>
                  </td>
                  <td colSpan={3} className='text-center font-print-24'>
                    <br/>
                    <div style={{visibility:(hideName1?'hidden':'')}}>........................................................</div>
                    <div style={{visibility:(hideName1?'hidden':'')}}>{docName==='receiptvoucher_doc'?'ผู้อนุมัติ/ผู้รับเงิน':'ผู้อนุมัติ'}</div>
                  </td>
                </tr>  
                :
                <tr style={{display:(dataItem.footer?'':'none')}}>
                  <td colSpan={showTaxInvoiceRefItem==='true'?4:2} className='text-center font-print-24 padding-0'>
                    <table className='table-print-payment-note-doc' style={{marginBottom:'0',width:'100%'}}>
                      <tbody>
                        {/* <tr><td className='bt-h bl-h'><br /></td><td className='bt-h br-h'><br /></td></tr> */}
                        <tr>
                          <td className='bt-h bb-h bl-h text-center' style={{width:'50%'}}>
                            <br />
                            ผู้ชำระเงิน..................วันที่....../....../......
                          </td>
                          <td className='bt-h bb-h br-h text-center' style={{width:'50%'}}>
                            <br />
                            ผู้รับเงิน...................วันที่....../....../......
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td colSpan={3} className='text-center font-print-24' style={{verticalAlign:'bottom'}}>
                    <br/>
                    <div>ผู้จัดทำ..................วันที่....../....../......</div>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
    )        
  }

  renderRowData(dataItem,dataIndex,length,number) {
    let {showTaxInvoiceRefItem,docName} = this.props
    let {itemPerPage} = this.state
    let start = 0
    if (number === 0) {
      start = 0
    } else {
      start = (number * itemPerPage)
    }
    
    if (dataItem.data.length===0) {
        return(<tr><td colSpan={showTaxInvoiceRefItem==='true'?7:5}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataItem.data.map((item,index) => {
                return(
                    <tr key={index}>
                        <td className={'font-print-24 text-center'+(index===0?'':' bt-h')}>{item.seq!==''?((start*1+1))+index:<br />}</td> {/* {item.seq!==''?number+index:<br />} */}
                        {showTaxInvoiceRefItem==='true'?
                        <td className={'font-print-24 text-center'+(index===0?'':' bt-h')}>{item.taxinvoice_no}</td>
                        :''}
                        {showTaxInvoiceRefItem==='true'?
                        <td className={'font-print-24 text-center'+(index===0?'':' bt-h')}>{item.taxinvoice_date}</td>
                        :''}
                        <td className={'font-print-24'+(index===0?'':' bt-h')}>{item.detail}</td>
                        <td className={'font-print-24 text-center'+(index===0?'':' bt-h')}>{docName==='paymentvoucher_doc'?this.getNumberFormat(this.getAmountBeforeVatPerRow(item)):this.getNumberFormat(item.total)}</td>
                        <td className={'font-print-24 text-right'+(index===0?'':' bt-h')}>{this.getNumberFormat(docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?item.vat:item.price_per_unit)}</td>
                        <td className={'font-print-24 text-right'+(index===0?'':' bt-h')}>{this.getNumberFormat(item.total)}</td>
                    </tr>
                )
            })
        )
    }    
  }

  renderReason() {
    let {data} = this.state
    let {docName} = this.props
    return(
      <div style={{marginTop:'10px',display:(docName==='receiptvoucher_doc'||docName==='paymentvoucher_doc'?'none':'')}}>
        <div className='remark'>สาเหตุจาก</div>
        <div className='remark' style={{borderBottom:'2px dotted #111'}}>{data.reason===''?'-':data.reason}</div>
      </div>  
    )
  }

  renderRemark() {
    let {data,options} = this.state
    let hideRemark = options.find((item,index)=>{
      return item.name==='show_remark'&&item.value
    })
    return(
      <div style={{marginTop:'10px',visibility:(hideRemark?'':'hidden')}}>
        <div className='remark'>หมายเหตุ</div>
        <div className='remark' style={{borderBottom:'2px dotted #111'}}>{data.remark}</div>
      </div>  
    )
  }

  onPayChange(value) {
    this.setState({pay_type:value})
  }

  // renderPayType() {
  //   let {pay_type} = this.state
  //   return(
  //                   <div>
  //                     ชำระเงินโดย
  //                     &nbsp;&nbsp;
  //                     <Checkbox
  //                       onChange={this.onPayChange.bind(this,'cash')}
  //                       checked={pay_type==='cash'?true:false}
  //                       checkboxClass="icheckbox_minimal"
  //                       increaseArea="20%"
  //                       label={' เงินสด'}
  //                     >
  //                     </Checkbox>
  //                     {' '}
  //                     <Checkbox
  //                       onChange={this.onPayChange.bind(this,'check')}
  //                       checked={pay_type==='check'?true:false}
  //                       checkboxClass="icheckbox_minimal"
  //                       increaseArea="20%"
  //                       label={' เช็ค'}
  //                     >
  //                     </Checkbox>
  //                     {' '}
  //                     <Checkbox
  //                       onChange={this.onPayChange.bind(this,'transfer')}
  //                       checked={pay_type==='transfer'?true:false}
  //                       checkboxClass="icheckbox_minimal"
  //                       increaseArea="20%"
  //                       label={' โอนเงิน'}
  //                     >
  //                     </Checkbox>
  //                     {' '}
  //                     <Checkbox
  //                       onChange={this.onPayChange.bind(this,'credit_card')}
  //                       checked={pay_type==='credit_card'?true:false}
  //                       checkboxClass="icheckbox_minimal"
  //                       increaseArea="20%"
  //                       label={' บัตรเครดิต'}
  //                     >
  //                     </Checkbox>
  //                   </div>
  //   )
  // }

  renderPayType() {
    let {pay_type,data} = this.state
    let {amount,withholdamount,witholdpercentage,condition_amount,fee_amount} = data
    return(
      <div>
        <table className='table-header-print-payment-note-doc' style={{marginBottom:'0',width:'100%'}}>
          <tbody>
            <tr><td className='text-left' colSpan={2}>ชำระเงินโดย</td></tr>
            <tr>
                    <td className='text-left' colSpan={2}>
                      <Checkbox
                        onChange={this.onPayChange.bind(this,'cash')}
                        checked={pay_type==='cash'?true:false}
                        checkboxClass="icheckbox_minimal"
                        increaseArea="20%"
                        label={' เงินสด'}
                      >
                      </Checkbox>
                      {' '}
                      <Checkbox
                        onChange={this.onPayChange.bind(this,'credit_card')}
                        checked={pay_type==='credit_card'?true:false}
                        checkboxClass="icheckbox_minimal"
                        increaseArea="20%"
                        label={' บัตรเครดิต'}
                      >
                      </Checkbox>
                  </td>
            </tr>
            <tr>      
                  <td className='text-left' colSpan={2}>
                      <Checkbox
                        onChange={this.onPayChange.bind(this,'transfer')}
                        checked={pay_type==='transfer'?true:false}
                        checkboxClass="icheckbox_minimal"
                        increaseArea="20%"
                        label={' โอนเงิน เลขที่บ/ช...............................'}
                      >
                      </Checkbox>
                  </td>
            </tr>  
            <tr>    
                  <td style={{width:'50%'}} className='text-left'>
                      <Checkbox
                        onChange={this.onPayChange.bind(this,'check')}
                        checked={pay_type==='check'?true:false}
                        checkboxClass="icheckbox_minimal"
                        increaseArea="20%"
                        label={' เช็คธนาคาร...................................'}
                      >
                      </Checkbox>
                  </td>
                  <td style={{width:'50%'}} className='text-center'>
                    สาขา...................................
                  </td>
            </tr>  
            <tr>
              <td className='text-left pay-type-padding'>
                เลขที่..................................
              </td> 
              <td className='text-center'>
                วันที่...................................
              </td>  
            </tr> 
            <tr>
              <td className='text-left pay-type-padding'>
               จำนวนเงิน......{this.getNumberFormat(amount - withholdamount - condition_amount - fee_amount)}........
              </td> 
              <td className='text-center'>
                ภาษีหัก ณ ที่จ่าย......{withholdamount>0?this.getNumberFormat(withholdamount):"....."}...........
              </td>  
            </tr>    
          </tbody>        
        </table>          
      </div>
    )
  }

  renderComponentPage(dataItem,dataIndex,length) { 
    return(
            <div key={dataIndex} className='font-print'>
              {this.renderHeader(dataItem,dataIndex)}
              {this.renderBody()}
              {this.renderCarDetail()}
              {this.renderTable(dataItem.data,dataIndex,dataItem.length,dataItem.number)}
              {dataItem.footer?this.renderReason():''}
              {dataItem.footer?this.renderRemark():''}
            </div>
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  getPagination(data,itemPerPage) {
    let checkRow = 0
    let newData = []
    let allData = []
    let footer = false
    if (data.length===0)
      data = this.newEmptyRow(itemPerPage)
    else if (itemPerPage>data.length)
      data = data.concat(this.newEmptyRow(itemPerPage-data.length))
      
    data.forEach((item,index)=>{
      if (index===0||index===itemPerPage-1)
        footer = false

      if (checkRow<itemPerPage) {
        newData.push(item)
      }
      if (checkRow===itemPerPage-1||index===data.length-1) {
        if (index===data.length-1)
          footer = true

        allData.push({
          data:newData,
          footer:footer
        })
        footer = false
        newData = []
        checkRow = -1
      }
      checkRow++
    })
    return allData
  }

  renderBtnSideBar() {
    return(
      <li class="">
        <a class="">
          <Button onClick={this.onSavePrintConfigOptions.bind(this)} bsStyle={'success'}><FontAwsome name='save' />บันทึก</Button>&nbsp;<Button onClick={this.onResetPrintConfigOptions.bind(this)} bsStyle={'danger'}><FontAwsome name='eraser' />รีเซ็ต</Button>
        </a>
      </li>
    )
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item,
                length:dataList.length,
                number:index
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item,
                length:dataList.length,
                number:index
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data,
                length:dataList.length,
                number:index
            })
        })
    }
    return pages
  }

  render(){    
    let {loading,defaultTypePrint,dataList,sizePage} = this.state
    let pages = this.setPageRender(dataList,defaultTypePrint)
    if (pages.length===0) {
      return(
        <PrintPreview
          loading={loading}
        >  
          {this.renderNoData()}
        </PrintPreview>  
      )
    } else {
      return(
        <div>
          <PrintPreview
            loading={loading}
            showSetting={true}            
            leftBarTitle={this.state.title+' '+this.props.docNo}
            onTypePrintChange={this.onTypePrintChange.bind(this)}
            defaultTypePrint={this.state.defaultTypePrint}
            optionSeting={this.state.options}
            onOptionSetingChange={this.onOptionSetingChange.bind(this)}
            onlineview={sizePage.page}
            optionSize={sizePage.page==='a4-onlineview'?'A4':'A5'}
            onOptionSizeChange={this.onOptionSizeChange.bind(this)}
            startRowPerPage={5}
            endRowPerPage={20}
            defaultRowPerPage={this.state.itemPerPage}
            showPageNumber={false}
            onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
            isPaperConfig={false}
          >
            {
              pages.map((item,index) => {
                return(
                  this.renderComponentPage(item,index,pages.length)
                )
              })
            }
          </PrintPreview>
          <NotificationSystem ref="notificationSystem" />
        </div>
      )
    }    
  }
}

PrintVoucherDoc.defaultProps = {
  title:'',  
  mode:'1',
  showTaxInvoiceRefItem:false
}

export default PrintVoucherDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintVoucherDoc.js